import { Drawer } from 'antd'
import React, { forwardRef, useImperativeHandle, useRef, useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { BASE_URL } from '../constants/Url';
import profile from "../assets/images/no-profile.png";
import { useSelector } from 'react-redux';
import { FaChevronDown } from "react-icons/fa6";

function MenuDrawer(props, ref) {
    const { listMenu, t, handleLogout, goToPage, authModalRef, technicalCategory = [] } = props;
    const location = useLocation();
    const navigate = useNavigate();
    const [open, setOpen] = useState(false);
    const [openFashion, setOpenFashion] = useState(false);
    const [openEducation, setOpenEducation] = useState(false);
    const [openProduct, setOpenProduct] = useState(() => window.location.pathname.startsWith("/product"));
    const user = useSelector((state) => state.authReducer);
    let token = user && user?.token ? user?.token : null 

    const onClose = () => setOpen(false);

    useImperativeHandle(ref, () => {
        return { open: () => setOpen(true) }
    })

    const isHomeActive = location.pathname === '/';
    const isNewsActive = location.pathname.startsWith('/news');
    const isFashionActive = location.pathname.startsWith('/fashion') || location.pathname.startsWith('/gallery');
    const isEducationActive = location.pathname.startsWith('/education') || location.pathname.startsWith('/online-class') || location.pathname.startsWith('/technical');
    const isProductActive = location.pathname.startsWith('/product');
    const isMagazineActive = location.pathname.startsWith('/magazine');

    return (
        <Drawer
            title={<img role='button' src={BASE_URL + "/logo.svg"}
            alt='ESI-Logo'
            onClick={() => {
                navigate("/");
                onClose();
            }} className='esi-logo' />}
            placement={"right"}
            onClose={onClose}
            open={open}
            rootClassName='custom-drawer'
        >
            <div className='flex flex-col justify-center gap-4'>
                <Link onClick={onClose} to="/" className={`esi-menu ${isHomeActive ? "active" : ""}`}>{t("text_homepage")}</Link>
                <Link onClick={onClose} to="/news" className={`esi-menu ${isNewsActive ? "active" : ""}`}>{t("menu_news")}</Link>

                <div className="flex flex-col">
                    <div className="flex justify-start items-center gap-2">
                        <span 
                            className={`esi-menu cursor-pointer ${isFashionActive ? "active" : ""}`}
                            onClick={() => { goToPage('/fashion'); onClose(); }}
                        >
                            {t("menu_fashion")}
                        </span>
                        <div 
                            className="px-2 py-1 cursor-pointer flex items-center justify-center"
                            onClick={() => setOpenFashion(!openFashion)}
                        >
                            <FaChevronDown className={`text-[12px] opacity-75 transition-transform ${openFashion ? 'rotate-180' : ''}`} />
                        </div>
                    </div>
                    {openFashion && (
                        <div className="flex flex-col gap-3 pl-4 mt-3">
                            <span onClick={() => { goToPage('/fashion/detail'); onClose(); }} className={`cursor-pointer ${location.pathname.startsWith('/fashion/detail') ? 'text-black font-bold' : 'text-gray-600 hover:text-black'}`}>{t("menu_theme")}</span>
                            <span onClick={() => { goToPage('/gallery/detail'); onClose(); }} className={`cursor-pointer ${location.pathname.startsWith('/gallery/detail') ? 'text-black font-bold' : 'text-gray-600 hover:text-black'}`}>{t("menu_creative")}</span>
                        </div>
                    )}
                </div>

                <div className="flex flex-col">
                    <div className="flex justify-start items-center gap-2">
                        <span 
                            className={`esi-menu cursor-pointer ${isEducationActive ? "active" : ""}`}
                            onClick={() => { goToPage('/education'); onClose(); }}
                        >
                            {t("menu_tech_edu")}
                        </span>
                        <div 
                            className="px-2 py-1 cursor-pointer flex items-center justify-center"
                            onClick={() => setOpenEducation(!openEducation)}
                        >
                            <FaChevronDown className={`text-[12px] opacity-75 transition-transform ${openEducation ? 'rotate-180' : ''}`} />
                        </div>
                    </div>
                    {openEducation && (
                        <div className="flex flex-col gap-3 pl-4 mt-3">
                            <span onClick={() => { goToPage('/online-class'); onClose(); }} className={`cursor-pointer ${location.pathname.startsWith('/online-class') ? 'text-black font-bold' : 'text-gray-600 hover:text-black'}`}>{t("menu_online_class")}</span>
                            {technicalCategory.map((category) => {
                                const isCatActive = decodeURIComponent(location.pathname).includes(category.value);
                                return (
                                    <span 
                                        key={category.name} 
                                        onClick={() => { goToPage(`/technical/detail/${category.value}`); onClose(); }} 
                                        className={`cursor-pointer ${isCatActive ? 'text-black font-bold' : 'text-gray-600 hover:text-black'}`}
                                    >
                                        {t(category.name)}
                                    </span>
                                );
                            })}
                        </div>
                    )}
                </div>

                <div className="flex flex-col">
                    <div className="flex justify-start items-center gap-2">
                        <span 
                            className={`esi-menu cursor-pointer ${isProductActive ? "active" : ""}`}
                            onClick={() => { goToPage('/product-knowledge'); onClose(); }}
                        >
                            {t("category_product")}
                        </span>
                        <div 
                            className="px-2 py-1 cursor-pointer flex items-center justify-center"
                            onClick={() => setOpenProduct(!openProduct)}
                        >
                            <FaChevronDown className={`text-[12px] opacity-75 transition-transform ${openProduct ? 'rotate-180' : ''}`} />
                        </div>
                    </div>
                    {openProduct && (
                        <div className="flex flex-col gap-3 pl-4 mt-3">
                            <span 
                                onClick={() => { goToPage('/product-knowledge'); onClose(); }} 
                                className={`cursor-pointer ${location.pathname.startsWith('/product-knowledge') ? 'text-black font-bold' : 'text-gray-600 hover:text-black'}`}
                            >
                                {t("menu_product_knowledge")}
                            </span>
                            <span 
                                onClick={() => { goToPage('/product'); onClose(); }} 
                                className={`cursor-pointer ${location.pathname.startsWith('/product') && !location.pathname.startsWith('/product-knowledge') ? 'text-black font-bold' : 'text-gray-600 hover:text-black'}`}
                            >
                                {t("menu_buy_product")}
                            </span>
                        </div>
                    )}
                </div>

                <Link onClick={onClose} to="/magazine" className={`esi-menu ${isMagazineActive ? "active" : ""}`}>{t("menu_magazine")}</Link>
            </div>
        </Drawer>
    )
};

export default forwardRef(MenuDrawer);
